import Swiper from "swiper";



$(document).ready(() => {
	let carouselBlock = $(".swiper-container.sc-members");




	if(carouselBlock.length) {

		let carousel = new Swiper('.swiper-container.sc-members', {
			slidesPerView: 3,
			slidesPerColumn: 2,
			spaceBetween: 24,
			breakpoints: {
				624: {
					slidesPerView: 5,
					slidesPerColumn: 2,
					arrows: true
				},
				992: {
					slidesPerView: 6,
					slidesPerColumn: 2,
					arrows: true
				},
				1200: {
					slidesPerView: 7,
					slidesPerColumn: 2,
					arrows: true
				}
			},

			pagination: {
				el: '.swiper-pagination',
				clickable: true
			},
			navigation: {
				nextEl: ".swiper-button-next",
				prevEl: ".swiper-button-prev"
			}
		});
	}


		/*// Initialize the carousel block
		carouselBlock.slick({
			centerMode: true,
			arrows: true,
			slidesToShow: 1,
			centerPadding: "25%",
			infinite: false,
			initialSlide: 1,
			dots: true,
			responsive: [
				{
					breakpoint: 768,
					settings: {
						centerPadding: "0",
						slidesToShow: 1
					}
				},
				{
					breakpoint: 0,
					settings: {
						centerPadding: "0",
						slidesToShow: 1
					}
				}

			]
		})
	}
	$(window).resize(function() {
		carouselBlock[0].slick.refresh();
	});*/
});
